<template>
  <div class="report-header">
    <div class="report-header__title-container">
      <h3 class="report-header__title" v-html="title" />
      <h5 class="report-header__subtitle" v-html="subtitle" />
    </div>
    <LogoComponent v-if="!hideLogo" :report-type-id="reportTypeId" />
  </div>
</template>

<script>
  import LogoComponent from '~/components/logo/LogoComponent.vue';

  export default {
    name: 'ReportHeader',
    components: {
      LogoComponent,
    },
    props: {
      reportTypeId: {
        type: [String, Number],
        // required: true,
      },
      title: {
        type: String,
        // required: true,
      },
      subtitle: {
        type: String,
        required: false,
      },
      hideLogo: Boolean,
    },
  };
</script>

<style lang="scss" scoped>
  .report-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 16px;

    &__title-container {
      flex: 1 auto;
    }
    &__title {
      margin-bottom: 5px;
    }
    &__subtitle {
      color: #3075a4;
      font-weight: 800;
      font-size: 18px;
    }
  }
</style>
